import React, { forwardRef, useState, useRef, useImperativeHandle, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import styles from './FJMobileTextarea.module.less';
import DeleteIcon from './../../../assets/svg/mobile-delete-gary.svg?react';
import FJUtil from '../../../util/FJUtil';
const FJMobileTextarea = (props, ref) => {
    const {
        text,
        onBlur,
        disabled,
        maxLength,
        onChange,
        onKeyDown,
        readOnly,
        placeholder,
        className,
        inputClassName,
        showLimit = true,
        footerBottom = 10,
    } = props;

    const [stateText, setStateText] = useState(text || '');
    const [isFocused, setIsFocused] = useState(false);
    const textareaRef = useRef(null);

    useImperativeHandle(ref, () => ({
        focus: () => {
            if (textareaRef.current) {
                textareaRef.current.focus();
            }
        },
        setText: text => {
            setStateText(text);
        },
        getTextarea: () => {
            return textareaRef.current;
        },
    }));

    useEffect(() => {
        if (text) {
            setStateText(text);
        }
    }, [text]);

    const _onBlur = e => {
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    };

    const _onFocus = e => {
        setIsFocused(true);
        if (props.onFocus) {
            props.onFocus(e);
        }
    };

    const _onKeyDown = useCallback(
        e => {
            if ((e.ctrlKey || e.metaKey) && e.keyCode === 65) {
                const value = textareaRef.current.value;
                textareaRef.current.value = '';
                textareaRef.current.value = value;
                textareaRef.current.select();
            }

            if (onKeyDown) {
                onKeyDown(e);
            }
        },
        [textareaRef, onKeyDown],
    );

    const _onChange = e => {
        setStateText(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    };
    const _onClear = e => {
        FJUtil.forbidEvent(e);
        setStateText('');
        if (onChange) {
            onChange('');
        }
        if (textareaRef.current) {
            setTimeout(() => {
                textareaRef.current.scrollTop = 0;
            }, 0);
            textareaRef.current.focus();
        }
    };
    const _onForbid = e => {
        e.preventDefault();
        e.stopPropagation();
        return;
    };

    const cnPanel = classNames(
        styles.textarea_box,
        isFocused ? styles.textarea_focus : '',
        disabled ? styles.textarea_disabled : '',
        className,
    );
    const isShowFooter = text && text.length > 0;
    return (
        <div className={cnPanel} onClick={_onForbid}>
            <textarea
                className={classNames(styles.content_textarea, inputClassName)}
                ref={textareaRef}
                readOnly={readOnly}
                value={stateText}
                placeholder={placeholder}
                onBlur={_onBlur}
                onKeyDown={_onKeyDown}
                onChange={_onChange}
                onFocus={_onFocus}
                maxLength={maxLength}
                disabled={disabled}
                onDragStart={_onForbid}
            />
            {isShowFooter && (
                <div className={styles.footer} style={{ bottom: footerBottom }}>
                    {showLimit && <span className={styles.num}>{text.length + '/' + maxLength}</span>}
                    <DeleteIcon className={styles.delete_icon} onClick={_onClear} />
                </div>
            )}
        </div>
    );
};

export default forwardRef(FJMobileTextarea);
